"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoMediaLayout = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _shared = require("../shared");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TwoMediaLayout = ({
  banner,
  debug,
  modulePosition,
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    modules,
    layout,
    id
  } = banner;
  if (modules == null || modules.length < 1) {
    return (0, _utils.getModulesContentAndLengthError)({
      debug,
      layout,
      modulePosition
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_editorialFetching.EditorialBannerLayoutEnum.TwoMedia),
    children: modules.map((module, index) => {
      const {
        title,
        titleStorybookColor
      } = module?.content ?? {};
      const link = module?.link;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key -- no unique index
        (0, _jsxRuntime.jsxs)(_styles.Wrapper, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.ImageBox, {
            id: id,
            module: module,
            imageParams: _constants.IMAGE_PARAMS.params,
            sizes: _constants.IMAGE_PARAMS.sizes,
            height: _constants.IMAGE_DESKTOP_HEIGHT,
            width: _constants.IMAGE_DESKTOP_WIDTH
          }), title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TitleWithDesktopMargin, {
            titleVariant: "h5",
            title: title,
            maxLines: 2,
            color: titleStorybookColor
          }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.Button, {
            link: link
          })]
        }, index)
      );
    })
  });
};
exports.TwoMediaLayout = TwoMediaLayout;
